
import Result from "../Interface/Result";
import Axios, { AxiosRequestConfig, AxiosError } from "axios";
import jsonToUrl from "json-to-url";

export interface IRequestOptions {
    url: string;
    data?: any;
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
}

export interface ISendFormDataOptions {
    url: string;
    data: FormData;
    method: "POST" | "PUT" | "PATCH";
}

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

/**
 * Represents base class of the isomorphic service.
 */
export abstract class BaseService {


    /**
     * Make request with JSON data.
     * @param opts
     */
    public static async requestJson<T>(opts: IRequestOptions): Promise<Result<T>> {
        var axiosResult = null;
        var result = null;


        var processQuery = (url: string, data: any): string => {
            if (data) {
                return `${url}?${jsonToUrl(data)}`;
            }
            return `${url}`;
        };

        var axiosOpts = {
            headers: {
                "Access-Control-Allow-Origin": "*"              
            }
        };
        
        try {
            switch (opts.method) {
                case "GET":
                    axiosResult = await Axios.get(processQuery(opts.url, opts.data), axiosOpts);
                    break;
                case "POST":
                    axiosResult = await Axios.post(opts.url, opts.data, axiosOpts);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, opts.data, axiosOpts);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, opts.data, axiosOpts);
                    break;
                case "DELETE":
                    axiosResult = await Axios.delete(processQuery(opts.url, opts.data), axiosOpts);
                    break;
            }
            result = new Result(axiosResult.data, axiosResult.status);
        } catch (error) {
            result = new Result(error.response ? error.response.data : '', error.response ? error.response.status : '');
        }

        return result;
    }

    /**
     * Allows you to send files to the server.
     * @param opts
     */
    public static async sendFormData<T>(opts: ISendFormDataOptions): Promise<Result<T>> {
        var axiosResult = null;
        var result = null;
        opts.url = `${baseUrl}${opts.url}`;

        try {
            switch (opts.method) {
                case "POST":
                    axiosResult = await Axios.post(opts.url, opts.data);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, opts.data);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, opts.data);
                    break;
            }
            result = new Result(axiosResult.data, axiosResult.status);
        } catch (error) {
            result = new Result(null);
        }


        return result;
    }


    public static getCookieValue(cookieName: string) {
        const allCookies = decodeURIComponent(document.cookie).split("; ");
        for (let i = 0; i < allCookies.length; i++) {
            const cookie = allCookies[i];
            if (cookie.startsWith(cookieName + "=")) {
                return cookie.substring(cookieName.length + 1);
            }
        }
        return "";
    }
}